import { LogService } from "@/services/LogService";
import store, { ApplicationModule, getStoreModule } from "@/store";
import { SearchItem } from "@/types";

/**
 * Provides functions to manage snackbar that is implemented in App.vue
 */
export class SnackbarService {
  private static applicationStore: ApplicationModule;

  private static _initialized = false;
  // To reset Vuetify timeout and clear old snackbar, timeout needs to change.
  // Increment default timeout to avoid new snackbar being ignored.
  private static _timeoutAdjustment = 0;

  static _initialize(): void {
    if (this._initialized) {
      LogService.warn("SnackbarService._initialize: service is already initialized.");
      return;
    }
    LogService.debug("Initializing SnackbarService.");

    this.applicationStore = getStoreModule(ApplicationModule, store);

    this._initialized = true;
    LogService.info("SnackbarService is initialized.");
  }

  public static displaySnackbar(
    message: string,
    color = "error",
    timeout = 3000,
    searchItem: SearchItem | null = null
  ): void {
    if (!this._initialized) {
      LogService.warn("SnackbarService.displaySnackbar is called before being initialized.");
      return;
    }
    if (this.applicationStore.getSnackbarState) {
      this._timeoutAdjustment++;
      LogService.debug(`SnackbarService: setting _timeoutAdjustment to ${this._timeoutAdjustment}.`);
    } else {
      this._timeoutAdjustment = 0;
    }
    // Update/clear the snackbar search item as needed so the select folders button does not appear
    this.applicationStore.setSnackbarItemBeingMoved(searchItem);

    this.applicationStore.setSnackbarColor(color);
    this.applicationStore.setSnackbarTimeout(timeout + this._timeoutAdjustment);
    this.applicationStore.setSnackbarMessage(message);
    this.applicationStore.setSnackbarState(true);
  }

  public static closeSnackbar(): void {
    this.applicationStore.setSnackbarState(false);
  }
}
